import { memo, useState, useEffect } from "react";
import styles from "./pdfRenderer.css";
import React from "react";

const PdfRenderer = ({ api }) => {
  const [pdfLink, setPdfLink] = useState("");
  console.log(pdfLink,"pdfLink")
  const onRowClick = (params) => {
    console.log(params, "params in pdf renderer");
    const pdfUrlPattern = /^https:\/\/files\.finkraft\.ai\/[a-f0-9]{32}$/;
    const findPdfUrl = (data) => {
      if (Array.isArray(data)) {
        for (let item of data) {
          const pdfUrl = findPdfUrl(item);
          if (pdfUrl) return pdfUrl;
        }
      } else if (typeof data === 'object' && data !== null) {
        for (let key in data) {
          if (data.hasOwnProperty(key)) {
            const pdfUrl = findPdfUrl(data[key]);
            if (pdfUrl) return pdfUrl;
          }
        }
      } else if (typeof data === 'string' && pdfUrlPattern.test(data)) {
  
        return data;
      }
      return null;
    };
    const pdfUrl = findPdfUrl(params.data);
    
    if (pdfUrl) {
      setPdfLink(pdfUrl);
    }
  };
  

 
  useEffect(() => {
    if (api) {
      api.addEventListener("rowClicked", onRowClick);
      return () => {
        api.removeEventListener("rowClicked", onRowClick);
      };
    }
  }, [api]);

  return (
    <div className={styles.pdfWrapper} style={{ width: 500, height: "100%" }}>
      <embed
        width="100%"
        height="600"
        src={pdfLink}
        type="application/pdf"
        style={{ height: "90%" }}
      ></embed>
    </div>
  );
};

export default memo(PdfRenderer);

// import { memo, useState, useEffect } from "react";
// import styles from "./pdfRenderer.css";
// import React from "react";

// const PdfRenderer = ({ api, pdfFieldName }) => {
//   console.log(pdfFieldName,"pdf field name")
//   console.log(api,"api")
//   const [pdfLink, setPdfLink] = useState("");

//   // Handler for row click event
//   // const onRowClick = (params) => {
//   //   console.log(params,"params in pdf renderer")
//   //   const pdfUrl = pdfFieldName;  
//   //   if (pdfUrl) {
//   //     setPdfLink(pdfUrl);
//   //   }
//   // };

//  const onRowClick = (params) => {
//   console.log(params, "params in pdf renderer");

//   // Regex pattern to match the PDF URL
//   const pdfUrlPattern = /^https:\/\/files\.finkraft\.ai\/[a-f0-9]{32}$/;

//   // Recursive function to search through nested objects and arrays
//   const findPdfUrl = (data) => {
//     if (Array.isArray(data)) {
//       // If it's an array, recursively search through each element
//       for (let item of data) {
//         const pdfUrl = findPdfUrl(item);
//         if (pdfUrl) return pdfUrl;
//       }
//     } else if (typeof data === 'object' && data !== null) {
//       // If it's an object, search through its properties
//       for (let key in data) {
//         if (data.hasOwnProperty(key)) {
//           const pdfUrl = findPdfUrl(data[key]);
//           if (pdfUrl) return pdfUrl;
//         }
//       }
//     } else if (typeof data === 'string' && pdfUrlPattern.test(data)) {

//       return data;
//     }
//     return null;
//   };
//   const pdfUrl = findPdfUrl(params.data);
  
//   if (pdfUrl) {
//     setPdfLink(pdfUrl);
//   }
// };

  

  // useEffect(() => {
  //   if (api) {
  //     api.addEventListener("rowClicked", onRowClick);

  //     // Clean up the event listener on component unmount
  //     return () => {
  //       api.removeEventListener("rowClicked", onRowClick);
  //     };
  //   }
  // }, [api, pdfFieldName]);

//   return (
//     <div className={styles.pdfWrapper} style={{ width: 500, height: "100%" }}>
//       {pdfLink ? (
//         <embed
//           width="100%"
//           height="600"
//           src={pdfLink}
//           type="application/pdf"
//           style={{ height: "90%" }}
//         ></embed>
//       ) : (
//         <p>No PDF selected</p>
//       )}
//     </div>
//   );
// };

// export default memo(PdfRenderer);

